import { ParsedUrlQuery } from 'querystring';

import { CSSProperties, useEffect, useMemo, useState } from 'react';

import dynamic from 'next/dynamic';
import { useSearchParams } from 'next/navigation';

import { useDevice } from '@contexts/device';
import { paramsToObject } from '@components/views/utils';

import { YearTabProps } from './interface';
import { getCurrentYearTab, getNextYearTab } from './helpers';

const MobileSearchMonthList = dynamic(() => import('./MobileSearchMonth'));
const DesktopSearchMonth = dynamic(() => import('./DesktopSearchMonth'));

interface Props {
  onMonthsUpdated: (months: YearTabProps[]) => void;
  isBookerSearch?: boolean;
  yearMonthsItemsStyle?: CSSProperties;
  landing?: boolean;
}

const SearchMonthDate = ({
  onMonthsUpdated,
  isBookerSearch,
  yearMonthsItemsStyle,
  landing,
}: Props) => {
  const { isDesktop } = useDevice();
  const searchParams = useSearchParams();
  const query: ParsedUrlQuery = useMemo(() => {
    return paramsToObject(searchParams?.entries());
  }, [searchParams]);

  const [selectedMonthsLabel, setSelectedMonthsLabel] = useState('');
  const [currentYearTab, setCurrentYearTab] = useState<YearTabProps>({
    year: getCurrentYearTab().year,
    months: [...getCurrentYearTab().months],
  });
  const [nextYearTab, setNextYearTab] = useState<YearTabProps>({
    year: getNextYearTab().year,
    months: [...getNextYearTab().months],
  });

  useEffect(() => {
    const selectedItems: string[] = [];

    currentYearTab.months?.map((month) => {
      if (month.checked) {
        selectedItems.push(`${month.abbreviation} ${currentYearTab.year}`);
      }
    });

    nextYearTab.months?.map((month) => {
      if (month.checked) {
        selectedItems.push(`${month.abbreviation} ${nextYearTab.year}`);
      }
    });

    setSelectedMonthsLabel(selectedItems.join(','));

    onMonthsUpdated([currentYearTab, nextYearTab]);
  }, [currentYearTab, nextYearTab]);

  useEffect(() => {
    const dateQuery = String(query?.date);
    if (!dateQuery) return;

    const checkedDates = dateQuery.split?.(',');

    setCurrentYearTab((val) => ({
      ...val,
      months: val.months.map((month) => {
        if (checkedDates?.includes(`${val.year}${month.number}`))
          return { ...month, checked: true };

        return { ...month, checked: false };
      }),
    }));

    setNextYearTab((val) => ({
      ...val,
      months: val.months.map((month) => {
        if (checkedDates?.includes(`${val.year}${month.number}`))
          return { ...month, checked: true };

        return { ...month, checked: false };
      }),
    }));
  }, [query]);
  return isDesktop ? (
    <DesktopSearchMonth
      currentYearTab={currentYearTab}
      nextYearTab={nextYearTab}
      setCurrentYearTab={setCurrentYearTab}
      setNextYearTab={setNextYearTab}
      selectedMonthsLabel={selectedMonthsLabel}
      isBookerSearch={isBookerSearch}
      yearMonthsItemsStyle={yearMonthsItemsStyle}
    />
  ) : (
    <MobileSearchMonthList
      landing={landing}
      currentYearTab={currentYearTab}
      nextYearTab={nextYearTab}
      setCurrentYearTab={setCurrentYearTab}
      setNextYearTab={setNextYearTab}
      selectedMonthsLabel={selectedMonthsLabel}
    />
  );
};

export default SearchMonthDate;
